import React from 'react';
import { Alert, Card, Col, Form, Row } from 'react-bootstrap';

export const money = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
export const num = (v) => Number(v || 0).toLocaleString('en-IN');
export const mins = (v) => `${Number(v || 0).toFixed(2)} min`;

export const KpiRow = ({ items = [] }) => (
  <Row className="g-3 mb-3">
    {items.map((item) => (
      <Col key={item.label} xl={3} md={4} sm={6}>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body>
            <div className="text-muted small">{item.label}</div>
            <h5 className={`mb-0 ${item.className || ''}`}>{item.value}</h5>
          </Card.Body>
        </Card>
      </Col>
    ))}
  </Row>
);

export const BranchFilter = ({ branches, value, onChange }) => (
  <Form.Group>
    <Form.Label>Branch</Form.Label>
    <Form.Select value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">All Branches</option>
      {(branches || []).map((b) => (
        <option key={b.branchId} value={b.branchId}>{b.branchName}</option>
      ))}
    </Form.Select>
  </Form.Group>
);

export const DateFilter = ({ label, value, onChange }) => (
  <Form.Group>
    <Form.Label>{label}</Form.Label>
    <Form.Control type="date" value={value} onChange={(e) => onChange(e.target.value)} />
  </Form.Group>
);

export const ReportError = ({ error }) => error ? <Alert variant="danger">{error}</Alert> : null;

export const gridSx = {
  backgroundColor: '#fff',
  '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f6f8fb' },
};
